import { CID } from 'multiformats/cid';

import { mapFileEntryToFileMetadata } from '@/store/mappers/mapSixDetail';
import { addFileMetadata } from '@/store/slices/poc/heliaSlice';
import { enqueueFile } from '@/store/slices/poc/cloneQueueSlice';
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { processCloneQueue } from '@/store/thunks/poc/cloneQueue/processCloneQueue';
import type { FileEntry } from '@/types/SixDetail.types';

export const syncFilesFromApiThunk = createAppAsyncThunk(
  'sixDetail/syncFilesFromApi',
  async(
    { sixId, files }: { sixId: string; files: FileEntry[] },
    { dispatch, extra: { pocServices, loggerService } },
  ) => {
    const log = loggerService.createLogger({ namespace: 'six3ro:six:sync-files' });
    const heliaNode = pocServices.p2pStackManagerService.getHeliaNode(sixId);

    if (heliaNode === null) {
      return { sixId, synced: 0, queued: 0, skipped: true };
    }

    const fileMetadataList = files
      .filter((item) => item.kind === 'file' && typeof item.cid === 'string' && item.cid.trim().length > 0)
      .map((item) => mapFileEntryToFileMetadata(item, sixId));

    let synced = 0;
    let queued = 0;

    for (const metadata of fileMetadataList) {
      try {
        const isPinned = await heliaNode.helia.pins.isPinned(CID.parse(metadata.cid));

        if (isPinned) {
          dispatch(addFileMetadata(metadata));
          synced++;
          continue;
        }

        dispatch(enqueueFile({
          sixId,
          cid: metadata.cid,
          metadata,
          size: metadata.size,
          priority: 'normal',
        }));
        queued++;
      } catch (error) {
        log.warn(`Failed to sync clone state for CID ${metadata.cid}`, error);
      }
    }

    if (queued > 0) {
      void dispatch(processCloneQueue());
    }

    return { sixId, synced, queued, skipped: false };
  },
);
